export default "__VITE_ASSET__WjDivjYP__"